export default "70fdd5d1d9ef4bb8.woff"